/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2

$(document).ready(function () {

  (function initStickyCalc() {
    var OFFSET = 10;
    var CALC_PADDING_V = 80;
    var HEADER_CHANGE_MIN_WIDTH = 1279;

    function getHeaderBottom() {
      var selectors = [
        'sticky-header',
        '#shopify-section-header header',
        '#shopify-section-header',
        '.site-header',
        '.header-wrapper',
        'header[role="banner"]',
        'header'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (!el) continue;
        var rect = el.getBoundingClientRect();
        if (rect.height > 0) return Math.max(0, rect.bottom);
      }
      return 0;
    }

    function update() {
      if ($(window).width() <= 1279) return;

      var winWidth = $(window).width();
      var headerBottom = winWidth > HEADER_CHANGE_MIN_WIDTH ? getHeaderBottom() : 0;
      var topOffset = headerBottom + OFFSET;

      $('.height-calculator').each(function () {
        var $section = $(this);
        var $calc = $section.find('.height-calculator__calc');
        var $content = $section.find('.height-calculator__calc-content');

        if (!$calc.length || $calc.css('position') !== 'sticky') return;

        if (!$calc.data('hc-transition-set')) {
          $calc.css('transition', 'top 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)');
          $content.css('transition', 'max-height 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)');
          $calc.data('hc-transition-set', true);
        }

        $calc.css('top', topOffset + 'px');

        var $body = $section.find('.height-calculator__body');
        var bodyRect = $body.length ? $body[0].getBoundingClientRect() : $section[0].getBoundingClientRect();

        var bodyVisibleTop = Math.max(bodyRect.top, topOffset);
        var bodyVisibleBot = Math.min(bodyRect.bottom, window.innerHeight);
        var bodyVisibleH   = Math.max(0, bodyVisibleBot - bodyVisibleTop);

        var maxH = bodyVisibleH - CALC_PADDING_V;

        if (maxH > 80) {
          $content.css('max-height', maxH + 'px');
        }
      });
    }

    var headerUpdateTimer;
    $(window).on('scroll', function () {
      requestAnimationFrame(update);
    });
    $(window).on('resize', function () {
      requestAnimationFrame(update);
      clearTimeout(headerUpdateTimer);
      headerUpdateTimer = setTimeout(update, 350);
    });
    update();
    $(window).on('load', update);
    setTimeout(update, 100);
    setTimeout(update, 500);
  })();

  (function initScrollReveal() {
    if (window.innerWidth <= 799 || typeof ScrollReveal === 'undefined') return;

    $('.height-calculator__body').each(function () {
      $(this).children().each(function (i, el) {
        ScrollReveal().reveal(el, {
          origin: 'bottom',
          distance: '20px',
          duration: 700,
          delay: 40 + (i * 40),
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          opacity: 0,
          scale: 1,
          once: true
        });
      });
    });
  })();

  (function initCustomSelects() {
    $('[data-custom-select]').each(function () {
      var $wrap = $(this);
      if ($wrap.data('customSelectInit')) return;
      $wrap.data('customSelectInit', true);

      var $native  = $wrap.find('.height-calculator__select-native');
      var $field   = $wrap.find('[data-select-field]');
      var $value   = $wrap.find('[data-select-value]');
      var $options = $wrap.find('.height-calculator__select-option');

      function closeList() {
        $wrap.removeClass('is-open');
      }

      function openList() {
        $('.height-calculator__custom-select.is-open').not($wrap).removeClass('is-open');
        $wrap.addClass('is-open');
      }

      $field.on('click', function (e) {
        e.stopPropagation();
        $wrap.hasClass('is-open') ? closeList() : openList();
      });

      $options.on('click', function () {
        var $option = $(this);
        var val = $option.data('value');

        $value.text($option.text());
        $wrap.addClass('has-value');
        $options.removeClass('is-selected');
        $option.addClass('is-selected');
        closeList();

        $native.val(String(val)).trigger('change');
      });

      $(document).on('click', function (e) {
        if (!$wrap.is(e.target) && $wrap.has(e.target).length === 0) {
          closeList();
        }
      });
    });
  })();

  function calcSeated(h) {
    return {
      desk:    {
        min: Math.max(58, Math.round(h * 0.3772)),
        max: Math.max(63, Math.round(h * 0.4072))
      },
      chair:   { min: Math.round(h * 0.2395), max: Math.round(h * 0.2695) },
      monitor: { min: Math.round(h * 0.6946), max: Math.round(h * 0.7246) },
    };
  }

 function calcStanding(h) {
    return {
      desk:    {
        min: Math.min(127, Math.round(h * 0.6347)),
        max: Math.min(133, Math.round(h * 0.6647))
      },
      monitor: { min: Math.round(h * 0.9401), max: Math.round(h * 0.9701) },
    };
  }

  function fmt(item, unit) {
    if (unit === 'in') {
      var min = Math.round(item.min / 2.54);
      var max = Math.round(item.max / 2.54);
      return min + '\'&ndash;' + max + '\' <span class="hc-result__unit"></span>';
    }
    return item.min + '&ndash;' + item.max + ' <span class="hc-result__unit">cm</span>';
  }

  function updateWrapper($wrap, data, unit) {
    $wrap.find('.height-calculator__result-desk-height .hc-result__value').html(fmt(data.desk, unit));

    if (data.chair) {
      $wrap.find('.height-calculator__result-chair-height .hc-result__value').html(fmt(data.chair, unit));
      $wrap.find('.hc-badge--chair .hc-badge__value').html(fmt(data.chair, unit));
    }

    $wrap.find('.height-calculator__result-monitor-height .hc-result__value').html(fmt(data.monitor, unit));
    $wrap.find('.hc-badge--desk .hc-badge__value').html(fmt(data.desk, unit));
    $wrap.find('.hc-badge--monitor .hc-badge__value').html(fmt(data.monitor, unit));
  }

  function clearWrapper($wrap) {
    $wrap.find('.hc-result__value, .hc-badge__value').html('&mdash;');
  }

  function getProductsByHeight(h) {
    if (h >= 145 && h <= 169) {
      return ['HomePro'];
    } else if (h >= 170 && h <= 195) {
      return ['HomePro', 'HomeOne', 'HomeMax'];
    } else if (h >= 196 && h <= 200) {
      return ['HomePro', 'HomeOne'];
    } else if (h >= 201 && h <= 205) {
      return ['HomePro'];
    }
    return [];
  }

  function updateShopBtn(h) {
    var products = getProductsByHeight(h);
    var $btn = $('a.height-calculator__result-btn');

    if (!$btn.length) return;

    var baseHref = $btn.data('original-href');
    if (!baseHref) {
      baseHref = $btn.attr('href');
      $btn.data('original-href', baseHref);
    }

    if (!products.length) {
      $btn.attr('href', baseHref);
      return;
    }

    var params = products.map(function (p) {
      return 'title=' + encodeURIComponent(p);
    }).join('&');

    var separator = baseHref.indexOf('?') > -1 ? '&' : '?';
    $btn.attr('href', baseHref + separator + params);
  }

  function getUnit() {
    return $('.height-calculator__calc-content').data('height-unit') || 'cm';
  }

  function getHeightCm(unit) {
    if (unit === 'in') {
      var feetVal   = $('.height-calculator__select-native[data-type="feet"]').val();
      var inchesVal = $('.height-calculator__select-native[data-type="inches"]').val();

      if (feetVal === undefined || inchesVal === undefined || feetVal === '' || inchesVal === '') {
        return null;
      }

      var totalInches = (parseInt(feetVal, 10) * 12) + parseInt(inchesVal, 10);
      return totalInches * 2.54;
    }

    var raw = parseFloat($('.height-calculator__input').val());
    return raw || null;
  }

  var currentMode = 'seated';

  $('.height-calculator__mode').on('click', function () {
    $('.height-calculator__mode').removeClass('active');
    $(this).addClass('active');
    currentMode = $(this).data('mode');
    calculate();
  });

  $('.height-calculator__input').on('input', calculate);
  $('.height-calculator__select-native').on('change', calculate);

  function calculate() {
    var unit          = getUnit();
    var $errorHolder  = $('.height-calculator__input');
    var $selects      = $('.height-calculator__select-native');
    var $error        = $('.height-calculator__input-error');
    var $output       = $('.height-calculator__output');
    var $placeholder  = $output.find('.height-calculator__output-placeholder');
    var $sitting      = $output.find('.height-calculator__result.sitting');
    var $standing     = $output.find('.height-calculator__result.standing');

    var hCm = getHeightCm(unit);

    function reset() {
      $error.text('').hide();
      $errorHolder.removeClass('height-calculator__input--error');
      $selects.removeClass('height-calculator__input--error');
      $output.removeClass('active');
      $placeholder.show();
      $sitting.hide();
      $standing.hide();
      clearWrapper($sitting);
      clearWrapper($standing);
    }

    if (!hCm) {
      reset();
      return;
    }

    var errorLow  = $errorHolder.data('error-low');
    var errorHigh = $errorHolder.data('error-high');

    if (hCm < 145 || hCm > 205) {
      $error.text(hCm < 145 ? errorLow : errorHigh).show();
      $errorHolder.addClass('height-calculator__input--error');
      $selects.addClass('height-calculator__input--error');
      $output.removeClass('active');
      $placeholder.show();
      $sitting.hide();
      $standing.hide();
      clearWrapper($sitting);
      clearWrapper($standing);
      return;
    }

    $error.text('').hide();
    $errorHolder.removeClass('height-calculator__input--error');
    $selects.removeClass('height-calculator__input--error');
    $output.addClass('active');
    $placeholder.hide();

    if (currentMode === 'seated') {
      $sitting.show();
      $standing.hide();
      updateWrapper($sitting, calcSeated(hCm), unit);
    } else {
      $standing.show();
      $sitting.hide();
      updateWrapper($standing, calcStanding(hCm), unit);
    }

    updateShopBtn(hCm);
  }

});